<template>
  <span
    v-if="loginFromIcon[type]"
    :class="loginFromIcon[type].className"
    :title="loginFromIcon[type].title"
    class="login-from-icon webkit-no-drag"
  />
</template>

<script>
export default {
  name: 'LoginFromIcon',
  props: {
    type: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loginFromIcon: {
        0: '',
        1: {
          className: 'loginfrm-wechat',
          title: '微信登录'
        },
        2: {
          className: 'loginfrm-qq',
          title: 'QQ登录'
        },
        3: {
          className: 'loginfrm-mobile',
          title: '手机登录'
        },
        90: {
          className: 'loginfrm-vip',
          title: '金山会员登录'
        }
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.login-from-icon {
  margin-top: -3px;
  vertical-align: 20px;
  display: inline-block;
  width: 19px;
  height: 18px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(~@/assets/images/userinfo/loginfrm-mobile.png);
  &.loginfrm-wechat {
    background-image: url(~@/assets/images/userinfo/loginfrm-wechat.png);
  }
  &.loginfrm-mobile {
    background-image: url(~@/assets/images/userinfo/loginfrm-mobile.png);
  }
  &.loginfrm-vip {
    background-image: url(~@/assets/images/userinfo/loginfrm-vip.png);
  }
  &.loginfrm-qq {
    background-image: url(~@/assets/images/userinfo/loginfrm-qq.png);
  }
}
</style>
